import { forwardRef, type InputHTMLAttributes } from 'react';
import './Input.css';

export type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /** Visual size — deliberately not named `size` (that's the native HTML
   * attribute controlling character-width, a different thing entirely). */
  uiSize?: InputSize;
  /** Renders the error visual state. Pair with `FieldGroup`'s `error` prop,
   * which also sets `aria-invalid` — this prop only controls appearance. */
  invalid?: boolean;
}

/** Text input. Use inside `FieldGroup` for label/help-text association. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { uiSize = 'md', invalid = false, className, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      className={[
        'dpr-input',
        `dpr-input--${uiSize}`,
        invalid ? 'dpr-input--invalid' : null,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  );
});
